import { useMemo } from 'react';
import { useApiQuery } from './useApiQuery';
import { connectionsApi } from '@/api/connections';
import type { ConnectionListResponse, PartnerConnection } from '@/api/connections';
import mockData from '@/data/mock-data.json';

interface UseConnectionsOptions {
  partnerId?: string;
  enabled?: boolean;
}

export const useConnections = (options: UseConnectionsOptions = {}) => {
  const { partnerId, enabled = true } = options;

  const mockConnections = useMemo<ConnectionListResponse>(() => {
    const all = mockData.partnerConnections as PartnerConnection[];
    return { connections: partnerId ? all.filter((c) => c.partnerId === partnerId) : all };
  }, [partnerId]);

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<ConnectionListResponse>(
    {
      queryFn: () => connectionsApi.list(partnerId),
      mockData: mockConnections,
      enabled,
    },
    [partnerId],
  );

  return {
    connections: data?.connections ?? [],
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
